/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseVideoFieldType = {
    UrlVideoType: 'VIDEO_FIELD_URL_VIDEO_TYPE',
    UploadedVideoType: 'VIDEO_FIELD_UPLOADED_VIDEO_TYPE'
} as const;
export type DatabaseVideoFieldType = typeof DatabaseVideoFieldType[keyof typeof DatabaseVideoFieldType];


export function DatabaseVideoFieldTypeFromJSON(json: any): DatabaseVideoFieldType {
    return DatabaseVideoFieldTypeFromJSONTyped(json, false);
}

export function DatabaseVideoFieldTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseVideoFieldType {
    return json as DatabaseVideoFieldType;
}

export function DatabaseVideoFieldTypeToJSON(value?: DatabaseVideoFieldType | null): any {
    return value as any;
}

